import updateStorages from 'core/controllerPlans/updateStorages'
import { IS_AGENT } from 'core/constants/environment'
import appStateUpdated from 'utils/appStateUpdated'
import getURLParams from 'utils/DOM/getURLParams'
import store from 'utils/store/withMiddleware'
import once from 'utils/functional/once'
import initPage from 'core/initPage'
import initDOM from './initDOM'
import config from './config'
import './styles.scss'
import forbidBTM from 'core/controllerPlansBTM/forbidBTM'
import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'

const urlParams = getURLParams()

function handleInit() {
  store.registry([once(initDOM), appStateUpdated])
  store.update({})
}

initPage({
  placement: config.placement,
  tags: ['Census'],
  clearStorage: IS_AGENT && !urlParams.backTo
})
  .then(forbidBTM)
  .then(updateStorages)
  .then(updateMultiCarrierEligibility)
  .then(handleInit)
